import {
  createStore,
  Store as VuexStore,
  CommitOptions,
  DispatchOptions,
} from "vuex";
import { State, state } from "./state";
import { Mutations, mutations } from "./mutations";
import { Actions, actions } from "./actions";

/**
 * This is used to create store for the Booza Game app.
 *
 * It is used for state management, it is also a common
 * place to store the data for the whole application.
 * It defines how the data is updated and listens for data updates.
 * It also defines the type of the data.
 */
export const store = createStore<State>({ state, mutations, actions });

export function useStore(): Store {
  return store as Store;
}

/**
 * This is to define Vuex store type for the entire Booza UI.
 *
 * The Vuex store is used to help the application communicate with the front end views.
 */
export type Store = Omit<VuexStore<State>, 'commit' | 'dispatch'> & {
  commit<K extends keyof Mutations, P extends Parameters<Mutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<Mutations[K]>;
} & {
  dispatch<K extends keyof Actions>(
    key: K,
    payload?: Parameters<Actions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<Actions[K]>;
};
